import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: GreenTurtwig
 * id 546D65EC-4458-49DA-AC96-54D8DB955FCA
 * name cards-playing-diamond-outline
 * version: 6.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cards-playing-diamond-outline.svg
 * tags
 * - Gaming / RPG 
 */
export const CardsPlayingDiamondOutlineIcon = createSvgIcon(<><path d="M17 2H7C5.9 2 5 2.9 5 4V20C5 21.1 5.9 22 7 22H17C18.1 22 19 21.1 19 20V4C19 2.9 18.1 2 17 2M17 20H7V4H17V20M12 7L9 12L12 17L15 12L12 7Z" /></>, 'CardsPlayingDiamondOutlineIcon');
export default CardsPlayingDiamondOutlineIcon